import React, { useState } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const InputDateRange = (
        {className,
         onChange,          /** (startDate, endDate) all date set work should be done here */
         onDateSelected,    /** (startDate, endDate) this handler is only intended to notify contaner to close menu, etc.. */
         onSetDatesClick,  /** (startDate, endDate) when use clickes tha Set Dates button */
         startDateText = 'Check-in',
         endDateText = 'Check-out',
         showSetDatesButton = true,
         ...rest}) => {

    const { t, i18n } = useTranslation();

    const locale = (i18n.language === 'en' || i18n.language === 'en-US') ? 'en-GB' : i18n.language;
    
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [activeStartDate, setActiveStartDate] = useState(
        () => new Date(startDate.getFullYear(), startDate.getMonth()+1, startDate.getDate())
    ); 
    
    const minDate = new Date();

    const handleChange = onChange||((startDate, endDate) => {});

    const handleStartDateChange = (date) => {
        setStartDate(date);
        if (date > endDate) {
            setEndDate(null); // Reset end date if invalid
            setActiveStartDate(new Date(date.getFullYear(), date.getMonth()+1, date.getDate()));
        }

        handleChange(date, endDate);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        handleChange(startDate, date);
        if (onDateSelected && startDate) {
            onDateSelected(startDate, date);
        }
    };

    const handeSetDatesClick = (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (onSetDatesClick)
            onSetDatesClick(startDate, endDate);
    }

    return (
        <div className={`criteria-date-range-drowpdown ${className}-drowpdown drowpdown`}>
            <div className='calendar-container'>
                <div className='date-boxes-wrapper'>
                    <div>
                        <label>{t(startDateText)}:</label>
                        <Calendar
                            onChange={handleStartDateChange}
                            value={startDate}
                            minDate={minDate} // Prevent past dates
                            locale={locale}
                            //showFixedNumberOfWeeks={true}
                            //selectRange={true}
                            //returnValue="range"
                            //showNavigation={false}
                            //showNeighboringMonth={false}
                            //formatShortWeekday={(locale, date) => date.toLocaleString('en', { weekday: 'narrow' })}
                        />
                    </div>
                    <div>
                        <label>{t(endDateText)}:</label>
                        <Calendar
                            onChange={handleEndDateChange}
                            activeStartDate={activeStartDate} // Controls which month is displayed
                            onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate(activeStartDate)} // Sync view changes
                            value={endDate}
                            minDate={startDate || new Date()} // Prevent end date before start date
                            locale={locale}
                        />
                    </div>
                    
                    {showSetDatesButton && (
                        <div className='button-container'>
                                <button className='button is-primary' onClick={handeSetDatesClick}>{t("Set Dates")}</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default InputDateRange;
